// Copyright 2021-2023 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @private Internal code, does not follow semantic versioning.
 */
export const headerContentType = "Content-Type";
export const headerUnaryContentLength = "Content-Length";
export const headerUnaryEncoding = "Content-Encoding";
export const headerStreamEncoding = "Connect-Content-Encoding";
export const headerUnaryAcceptEncoding = "Accept-Encoding";
export const headerStreamAcceptEncoding = "Connect-Accept-Encoding";
export const headerTimeout = "Connect-Timeout-Ms";
export const headerProtocolVersion = "Connect-Protocol-Version";
export const headerUserAgent = "User-Agent";
